import clsx from "clsx";
import { motion } from "framer-motion";
import { Share2 } from "lucide-react";
import { useRouter } from "next/compat/router";
import posthog from "posthog-js";

import useQueryParam from "~/hooks/useQueryParam";
import { buttonVariants } from "~/lib/animations.lib";

interface ShareButtonProps {
	isIconButton?: boolean;
	href?: string;
	id?: string;
	className?: string;
}

const ShareButton = ({
	href,
	isIconButton,
	id,
	className,
}: ShareButtonProps) => {
	const [, setShareParam] = useQueryParam("share");
	const router = useRouter();

	return (
		<motion.button
			whileTap={buttonVariants.loading}
			id={id}
			onClick={() => {
				setShareParam(href || router?.asPath);
				posthog.capture("share_button_clicked", {
					content_path: href || router?.asPath,
				});
			}}
			className={clsx(
				"flex h-min max-w-max shrink-0 items-center justify-center gap-1.5 phablet:gap-2 rounded-full bg-orange-100 phablet:px-3 px-4 phablet:py-1.5 py-2 font-medium text-base text-orange-900 hover:bg-orange-200 dark:bg-orange-400/20 dark:text-orange-50 dark:hover:bg-orange-400/30",
				className,
			)}
		>
			<Share2 className="h-5 w-5 shrink-0" />
			{!isIconButton && <span className="phablet:block hidden">Share</span>}
		</motion.button>
	);
};

export default ShareButton;
